export const PATHS = {
  HAVE_ACCOUNT: 'have-account',
  CREATE_ACCOUNT: 'create-account',
  FORGOT_PASSWORD: 'forgot-password',
  LOGIN_BY_USERNAME: 'login-by-username',
  LOGIN_BY_SOCIALS: 'login-by-socials',
  OTHER_SOCIALS: 'other-socials',
  OTHER_NO_EMAIL: 'other-no-email'
};

export const pathByLabel = {
  [PATHS.HAVE_ACCOUNT]: '/',
  [PATHS.LOGIN_BY_USERNAME]: '/', // only in compactView
  [PATHS.CREATE_ACCOUNT]: '/registration',
  [PATHS.FORGOT_PASSWORD]: '/reset-password',
  [PATHS.LOGIN_BY_SOCIALS]: '/socials',
  [PATHS.OTHER_NO_EMAIL]: '/other/noemail',
  [PATHS.OTHER_SOCIALS]: '/other'
};



// WEBPACK FOOTER //
// ./utils/urlPaths.js